import { Component } from '@angular/core';

@Component({
  selector: 'app-lite-tournament-section',
  imports: [],
  templateUrl: './lite-tournament-section.html',
  styleUrl: './lite-tournament-section.css',
})
export class LiteTournamentSection {}
